

// src/store.js
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import createIndexedDBStorage from 'redux-persist-indexeddb-storage';

import authReducer from './slice/authSlice';
import bulkUploadSlice from './slice/bulkUploadSlice';
import globalDataSlice from './slice/globalData';
import chatSlice from './slice/chatSlice'

// Use IndexedDB instead of localStorage
const storage = createIndexedDBStorage({
  name: 'myAppDB',       // Name of the IndexedDB database
  storeName: 'persistedStore', // Name of the object store (like a table)
});

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'bulkUploadData', 'chat'], // Persisted slices
};

// Combine reducers into a single root reducer
const rootReducer = combineReducers({
  auth: authReducer,
  bulkUploadData: bulkUploadSlice,
  globalDataSlice, // This won't be persisted
  chat:chatSlice
});

// Create the persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the Redux store
const store = configureStore({
  reducer: persistedReducer,
});

// Create the persistor
const persistor = persistStore(store);

export { store, persistor };
